/* AdiBody - Scelta consegna nel carrello: "Consegna a domicilio" / "Ritiro in ufficio postale".
   Salva negli attributi del carrello (-> ordine Shopify): Consegna, Ufficio postale, _Ufficio postale codice (codice Poste).
   La finestra con l'elenco degli uffici e in ab-uffici.js. */
(function () {
  if (window.__abConsegna) return;
  window.__abConsegna = true;

  var DOMICILIO = 'A domicilio';
  var RITIRO = 'Ritiro in ufficio postale';

  var stato = { modo: '', ufficio: '' };

  /* ---------------- utilità ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function salva(attributi) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributi })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  /* ---------------- blocco nel carrello ---------------- */
  function disegnaBlocco(box) {
    var ritiro = stato.modo === RITIRO;
    box.innerHTML =
      '<p class="ab-consegna__titolo">Come vuoi ricevere il pacco?</p>' +
      '<div class="ab-consegna__opzioni" role="radiogroup" aria-label="Modalità di consegna">' +
      '<button type="button" role="radio" class="ab-consegna__opzione" data-ab-modo="domicilio" aria-checked="' + (stato.modo === DOMICILIO) + '">' +
      '<span class="ab-consegna__icona" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M10 21v-6h4v6"/></svg>' +
      '</span><span><strong>Consegna a domicilio</strong><small>Al tuo indirizzo</small><em class="ab-consegna__gratis" style="display:block;margin-top:3px;font-style:normal;font-size:1.05rem;font-weight:700;letter-spacing:.06em;color:#b9804f">GRATUITA</em></span></button>' +
      '<button type="button" role="radio" class="ab-consegna__opzione" data-ab-modo="ritiro" aria-checked="' + ritiro + '">' +
      '<span class="ab-consegna__icona" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>' +
      '</span><span><strong>Ritiro in ufficio postale</strong><small>Scegli il più comodo</small><em class="ab-consegna__gratis" style="display:block;margin-top:3px;font-style:normal;font-size:1.05rem;font-weight:700;letter-spacing:.06em;color:#b9804f">GRATUITO</em></span></button>' +
      '</div>' +
      (ritiro
        ? stato.ufficio
          ? '<div class="ab-consegna__scelto"><span>Ritirerai presso<br><strong>' + esc(stato.ufficio) + '</strong></span>' +
            '<button type="button" class="ab-consegna__link" data-ab-apri>Cambia</button></div>' +
            '<p class="ab-consegna__nota">Al checkout inserisci comunque nome, indirizzo e telefono: servono per contattarti. Il pagamento alla consegna è disponibile anche in ufficio postale.</p>'
          : ''
        : '') +
      '<p class="ab-consegna__errore" hidden></p>';
  }
  function aggiornaTutti() {
    document.querySelectorAll('[data-ab-consegna]').forEach(disegnaBlocco);
  }
  // stato salvato nel carrello (scritto da Liquid nella sezione ab-consegna)
  var iniziale = window.abConsegnaStato || {};
  stato.modo = iniziale.modo || '';
  stato.ufficio = iniziale.ufficio || '';
  // la scelta resta solo mentre il cliente sta navigando: dopo 30 minuti senza aprire il sito si azzera,
  // cosi chi torna dopo non trova una scelta vecchia preselezionata (e non compra per sbaglio con il ritiro)
  var CHIAVE = 'abConsegnaScelta', DURATA = 30 * 60 * 1000;
  function sceltaRecente() {
    try { var t = +localStorage.getItem(CHIAVE); return !!t && Date.now() - t < DURATA; } catch (e) { return true; }
  }
  function segnaScelta() {
    try { localStorage.setItem(CHIAVE, String(Date.now())); } catch (e) {}
  }
  if ((stato.modo || stato.ufficio) && !sceltaRecente()) {
    stato.modo = '';
    stato.ufficio = '';
    salva({ Consegna: '', 'Ufficio postale': '', '_Ufficio postale codice': '', '_Ufficio postale coordinate': '' }).catch(function () {});
  } else if (stato.modo) {
    segnaScelta(); // sta ancora navigando: i 30 minuti ripartono
  }
  function errore(testo) {
    document.querySelectorAll('[data-ab-consegna] .ab-consegna__errore').forEach(function (p) {
      p.textContent = testo || '';
      p.hidden = !testo;
    });
  }

  function scegliModo(modo) {
    errore('');
    segnaScelta();
    if (modo === 'domicilio') {
      stato.modo = DOMICILIO;
      stato.ufficio = '';
      aggiornaTutti();
      salva({ Consegna: DOMICILIO, 'Ufficio postale': '', '_Ufficio postale codice': '', '_Ufficio postale coordinate': '' }).catch(function () {
        errore('Non siamo riusciti a salvare la scelta. Riprova.');
      });
    } else {
      stato.modo = RITIRO;
      aggiornaTutti();
      if (!stato.ufficio) apriModale();
      salva({ Consegna: RITIRO }).catch(function () {
        errore('Non siamo riusciti a salvare la scelta. Riprova.');
      });
    }
  }

  function apriModale() {
    if (window.abUffici) window.abUffici.apri(scegliUfficio);
  }
  function scegliUfficio(u) {
    if (!u) return;
    segnaScelta();
    var testo = u.nome + (u.indirizzo ? ' – ' + u.indirizzo : '');
    stato.modo = RITIRO;
    stato.ufficio = testo;
    aggiornaTutti();
    salva({
      Consegna: RITIRO,
      'Ufficio postale': testo + (u.codice ? ' (cod. ' + u.codice + ')' : ''),
      '_Ufficio postale codice': u.codice || '',
      '_Ufficio postale coordinate': Number(u.lat).toFixed(6) + ',' + Number(u.lon).toFixed(6)
    }).catch(function () {
      errore('Non siamo riusciti a salvare l\'ufficio scelto. Riprova.');
    });
  }

  /* ---------------- eventi ---------------- */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-ab-consegna] [data-ab-modo]');
    if (m) return scegliModo(m.getAttribute('data-ab-modo'));
    if (e.target.closest('[data-ab-consegna] [data-ab-apri]')) return apriModale();

    // blocca il checkout se non ha scelto come ricevere il pacco, o se ha scelto il ritiro ma non l'ufficio
    var checkout = e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"]');
    if (checkout && !stato.modo) {
      e.preventDefault();
      e.stopImmediatePropagation();
      errore('Scegli come vuoi ricevere il pacco: a domicilio o in ufficio postale.');
      return;
    }
    if (checkout && stato.modo === RITIRO && !stato.ufficio) {
      e.preventDefault();
      e.stopImmediatePropagation();
      errore('Scegli l\'ufficio postale dove vuoi ritirare il pacco.');
      apriModale();
    }
  }, true);

  // metto il blocco sopra ogni pulsante "Procedi all'ordine" (carrello laterale e pagina carrello).
  // Il carrello laterale si ridisegna a ogni modifica: lo rimetto ogni volta.
  function scansiona() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prima = ctas.previousElementSibling;
      if (prima && prima.hasAttribute('data-ab-consegna')) return;
      var vuoto = ctas.querySelector('button[name="checkout"][disabled]');
      if (vuoto) return;
      var box = document.createElement('div');
      box.className = 'ab-consegna';
      box.setAttribute('data-ab-consegna', '');
      ctas.parentNode.insertBefore(box, ctas);
      disegnaBlocco(box);
    });
  }
  new MutationObserver(scansiona).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scansiona);
  else scansiona();
})();
